import cookie from 'js-cookie';

// import { isStandaloneApp, getMobileOperatingSystem } from 'app/utils/browser';
import { getPlatform } from 'app/utils/leadPlatform';
import { getUTMParams } from 'app/utils/utmParams';
import { analyticService } from 'global/services';

import { currentPhoneVar } from 'app/apollo/reaction';
import { getClient } from './client';


const LEAD_MUTATION = `
    mutation pushLead(
        $date: String
        $email: String
        $phone: String
        $name: String
        $form_name: String
        $source: leadSource
        $subscription: leadSubscription
        $utm: leadUtm
        $ga_client_id: String
        $admitad_uid: String
        $roistat_visit: String
        $request_questions: String
        $platform: platform
    ) {
        pushLead(
            date: $date
            email: $email
            phone: $phone
            name: $name
            form_name: $form_name
            source: $source
            utm: $utm
            ga_client_id: $ga_client_id
            admitad_uid: $admitad_uid
            roistat_visit: $roistat_visit
            request_questions: $request_questions
            subscription: $subscription
            platform: $platform
        ) {
            success
            isNewbie
            isFirstLead
            id
        }
    }
`;


const SURVEY_TYPE_SITE = 6; // checkoutv4_site

function getVariables(formVariables) {
    const {
        formName,
        sourceSurvey,
        comments,
        phone,
        email,
        name,
        referrerCode,
        requestQuestion,
    } = formVariables;

    const date = new Date();

    const utm = getUTMParams();

    const questionStart = sourceSurvey ? sourceSurvey.toUpperCase() : 'BASEE 5x2';

    const fullQuestion = [
        questionStart,
        'Откуда: заявка с сайта',
        `Что: ${formName}`,
        `Комментарий: ${comments}`,
        'Как связаться:',
    ].join('; ');

    const fullRequestQuestion = [
        requestQuestion,
        'Откуда: заявка с сайта',
        `Что: ${requestQuestion}`,
        `Комментарий: ${comments}`,
        'Как связаться:',
    ].join('; ');

    return {
        date: date.toLocaleDateString('en'),
        phone,
        email,
        name,
        form_name: formName,
        source: {
            survey: sourceSurvey,
            type: SURVEY_TYPE_SITE,
        },
        utm,
        ga_client_id: cookie.get('_ga_cid'),
        admitad_uid: cookie.get('_aid'),
        roistat_visit: cookie.get('roistat_visit'),
        request_questions: requestQuestion ? fullRequestQuestion : fullQuestion,
        subscription: {
            profile: {
                referrer_code: referrerCode,
            },
        },
        platform: getPlatform(),
    };
}


export default async function pushLead(options) {
    const variables = getVariables(options);

    const client = getClient();

    const resp = await client.query(
        LEAD_MUTATION,
        variables,
    );

    const { data: { pushLead: leadData } } = resp;
    const { phone, email } = variables;

    const eventData = {
        ...leadData,
        eventName: 'Lead_Sent',
        phone,
        email,
        lead_type: SURVEY_TYPE_SITE,
    };

    analyticService.push(eventData);

    if (leadData.isFirstLead) {
        analyticService.push({
            ...eventData,
            eventName: 'Lead_Sent_First',
        });
    }

    return resp;
}
